import type { Contract } from "@iyk/vf-core"
import type { Profile } from "../profile.ts"

import { Array, DateTime, Option } from "effect"

export const AttributesList = ({ attributes }: AttributesList.Props) => {
  if (Array.isEmptyArray(attributes)) {
    return null
  }

  return (
    <ul className="flex flex-col gap-2 list-inside">
      {attributes.map((attribute, index) => (
        <li
          key={index}
          className="relative text-sm pl-5 before:absolute before:top-0 before:left-0 before:content-['—']"
        >
          {attribute.type}: {attribute.value}
        </li>
      ))}
    </ul>
  )
}

export namespace AttributesList {
  export type Props = {
    attributes: Array<Profile.Attribute>
  }
}

export const toAttributes = (attributes: Contract.TokenMetadata["attributes"]): Array<Profile.Attribute> => {
  return attributes.map((attr) => {
    if (attr.display_type === "date") {
      const date = DateTime.make(Number(attr.value) * 1000).pipe(
        Option.map((date) =>
          DateTime.format(date, {
            month: "short",
            day: "numeric",
            year: "numeric"
          })
        ),
        Option.getOrElse(() => attr.value.toString())
      )

      return {
        type: attr.trait_type,
        value: date
      }
    }

    return {
      type: attr.trait_type,
      value: attr.value.toString()
    }
  })
}
